import React, { useState, useEffect, useCallback } from "react";
import { FlexCol, FlexRow } from "../generic/Containers";
import { BCIcon, ICONS } from "../generic/BCIcons";
import {BCHeader2, BCHeader3, BCHeader4, Body2} from "../generic/BCHeaders";
import { BCPrimaryButton } from "../generic/BCButtons";
import { useGlobalState } from "../../GlobalState";
import { IconType } from "react-icons";
import { ref, getDownloadURL } from "firebase/storage";
import { storage } from "../../util/Firebase";
import { REFERENCES_TYPES_CONFIG } from "../../constants/ReferencesTypesConfig";
import { ReferenceItem } from "../../models/Reference";
import { BCTagList } from "../generic/BCTag";
import { useDropzone } from "react-dropzone";
import "./LandingPageOverviewComponent.css";
import MockInterviewThumbnail from "../../images/mock-interview-preview-thumbnail-2.jpg";

type PreviewType = 'video' | 'pdf' | 'reference' | 'tool';

type LandingPageOverviewType = {
    step: number;
    header: string;
    educationHeader: string;
    icon: IconType;
    previewTitle: string;
    previewCaption: string;
    background: string;
    primary: string;
    borderColor: string;
    previewType: PreviewType;
    previewUrl?: string;
    thumbnailUrl?: string;
    referenceId?: string;
    ctaText: string;
    ctaEducatorText: string;
    bullets: Array<{ icon: IconType; text: string }>;
    isInverted: boolean;
}

// export const LANDING_PAGE_OVERVIEW_TYPES = {
//     SECTION_1: {
//         step: 1,
//         header: "Learn More Than Just Code",
//         educationHeader: "We Cover What Others Don't.",
//         icon: ICONS.LESSONS,
//         previewTitle: "Real-World Tech Courses",
//         previewCaption: "Watch a 2-minute sample lesson",
//         background: 'linear-gradient(35deg, #f8faff 0%, #e8f4f8 100%)',
//         primary: '#3b82f6',
//         borderColor: '#bfdbfe',
//         previewType: 'video' as PreviewType,
//         previewUrl: "courses/debugging-101/03_types_of_errors.mp4",
//         ctaText: 'Start Learning',
//         ctaEducatorText: 'Learn More',
//         bullets: [
//             { icon: ICONS.MAP, text: "Practical skills most courses skip (debugging, APIs, Git, project workflows)" },
//             { icon: ICONS.LESSONS, text: "Language-agnostic lessons that apply to any tech stack" }
//         ],
//         isInverted: true
//     },
//     SECTION_2: {
//         step: 2,
//         header: "Learn From Real Engineers",
//         educationHeader: "We take new developers from coding exercises to portfolio-ready work.",
//         icon: ICONS.VIDEO,
//         previewTitle: "Real Mock Interviews",
//         previewCaption: "Watch a real entry-level mock interview",
//         background: 'linear-gradient(135deg, #fff7f2 0%, var(--primary2) 100%)',
//         primary: 'var(--primary1)',
//         borderColor: 'rgba(235, 91, 4, 0.35)',
//         previewType: 'video' as PreviewType,
//         previewUrl: "interviews/clyde,_big_tech_company_-_entry_level_mock_interview.mp4",
//         ctaText: 'Watch More Interviews',
//         ctaEducatorText: 'Learn More',
//         bullets: [
//             { icon: ICONS.VIDEO, text: "See what technical + behavioral interviews actually feel like" },
//             { icon: ICONS.BOOK, text: "Learn how strong candidates think, communicate, and recover" }
//         ],
//         isInverted: false
//     },
//
//     SECTION_3: {
//         step: 3,
//         header: "Build a Real Portfolio",
//         educationHeader: "We Get Students Job Search Ready.",
//         icon: ICONS.SPARKLE,
//         previewTitle: "Portfolio Resources for New Devs",
//         previewCaption: "Explore beginner-friendly APIs for real projects",
//         background: 'linear-gradient(135deg, #f5f3ff 0%, #e7f5e8 100%)',
//         primary: '#2e7c31',
//         borderColor: '#2e7c31',
//         previewType: 'reference' as PreviewType,
//         referenceId: "beginner-friendly-apis",
//         ctaText: 'Build Portfolio Projects',
//         ctaEducatorText: 'Learn More',
//         bullets: [
//             { icon: ICONS.CODE, text: "Curated APIs + project ideas that make building feel doable" },
//             { icon: ICONS.PDF, text: "Templates and checklists to present projects professionally" }
//         ],
//         isInverted: true
//     },
//
//     SECTION_4: {
//         step: 4,
//         header: "Stand Out as an Applicant",
//         educationHeader: "We Help Students Land Jobs With Confidence.",
//         icon: ICONS.SEARCH,
//         previewTitle: "Job Search Tools",
//         previewCaption: "Try the AI resume analyzer in seconds",
//         background: 'linear-gradient(135deg, #f5f3ff 0%, #e8e5ff 100%)',
//         primary: '#8b5cf6',
//         borderColor: '#c4b5fd',
//         previewType: 'tool' as PreviewType,
//         ctaText: 'Improve My Resume',
//         ctaEducatorText: 'Learn More',
//         bullets: [
//             { icon: ICONS.SPARKLE, text: "AI-powered resume feedback to fix common mistakes fast" },
//             { icon: ICONS.PEN, text: "Clear, step-by-step guidance for resumes, cover letters, and applications" }
//         ],
//         isInverted: false
//     },
//
//     SECTION_5: {
//         step: 5,
//         header: "Interview With Confidence",
//         educationHeader: "We Help Students Land Jobs With Confidence.",
//         icon: ICONS.BOOK,
//         previewTitle: "Interview Study Guides",
//         previewCaption: "Browse a real interview prep guide",
//         background: 'linear-gradient(135deg, #fff7f2 0%, #ffeee5 100%)',
//         primary: '#ea580c',
//         borderColor: '#fed7aa',
//         previewType: 'pdf' as PreviewType,
//         previewUrl: "resources/Ultimate Coding Interview Study Guide.pdf",
//         ctaText: 'Get Interview Ready',
//         ctaEducatorText: 'Learn More',
//         bullets: [
//             { icon: ICONS.BOOK, text: "Study guides for both technical and behavioral interviews" },
//             { icon: ICONS.CHALLENGES, text: "Practice questions and problems modeled after real interviews" }
//         ],
//         isInverted: true
//     }
// }

export const LANDING_PAGE_OVERVIEW_TYPES = {
    SECTION_1: {
        step: 2,
        header: "Learn From Real Engineers",
        educationHeader: "We take new developers from coding exercises to portfolio-ready work.",
        icon: ICONS.VIDEO,
        previewTitle: "Real Mock Interviews",
        previewCaption: "Watch a real entry-level mock interview",
        background: 'linear-gradient(135deg, #fff7f2 0%, var(--primary2) 100%)',
        primary: 'var(--primary1)',
        borderColor: 'rgba(235, 91, 4, 0.35)',
        previewType: 'video' as PreviewType,
        previewUrl: "interviews/clyde,_big_tech_company_-_entry_level_mock_interview.mp4",
        thumbnailUrl: MockInterviewThumbnail,
        ctaText: 'Watch More Interviews',
        ctaEducatorText: 'Learn More',
        bullets: [
            { icon: ICONS.VIDEO, text: "Realistic technical and behavioral mock interviews" },
            { icon: ICONS.LIGHTBULB, text: "Advice and strategies from experienced engineers" },
            { icon: ICONS.EYE, text: "Practical insight into how hiring decisions are made" }
        ],
        isInverted: true
    },
    SECTION_2: {
        step: 4,
        header: "Stand Out as an Applicant",
        educationHeader: "We Help Students Land Jobs With Confidence.",
        icon: ICONS.SEARCH,
        previewTitle: "Job Search Tools",
        previewCaption: "Try the AI resume analyzer in seconds",
        background: 'linear-gradient(135deg, #f5f3ff 0%, #e8e5ff 100%)',
        primary: '#ea580c',
        borderColor: '#fed7aa',
        previewType: 'tool' as PreviewType,
        ctaText: 'Improve My Resume',
        ctaEducatorText: 'Learn More',
        bullets: [
            { icon: ICONS.SPARKLE, text: "Tools to improve resumes and cover letters" },
            { icon: ICONS.RESUME, text: "Example resumes from successful candidates" },
            { icon: ICONS.HANDSHAKE, text: "Guidance on applications, networking, and outreach" }
        ],
        isInverted: false
    },

    SECTION_5: {
        step: 5,
        header: "Interview With Confidence",
        educationHeader: "We Help Students Land Jobs With Confidence.",
        icon: ICONS.BOOK,
        previewTitle: "Interview Study Guides",
        previewCaption: "Browse a real interview prep guide",
        background: 'linear-gradient(135deg, #fff7f2 0%, #ffeee5 100%)',
        primary: '#ea580c',
        borderColor: '#fed7aa',
        previewType: 'pdf' as PreviewType,
        previewUrl: "resources/Ultimate Coding Interview Study Guide.pdf",
        ctaText: 'Get Interview Ready',
        ctaEducatorText: 'Learn More',
        bullets: [
            { icon: ICONS.BOOK, text: "Resources and guides to master tech interviews" },
            { icon: ICONS.CODE, text: "Coding challenges to sharpen problem-solving skills" },
            { icon: ICONS.LESSONS, text: "Courses on both technical and behavioral interviewing" }
        ],
        isInverted: true
    }
}

const VideoPreview: React.FC<{ fileUrl: string; thumbnailUrl?: string }> = ({ fileUrl, thumbnailUrl }) => {
    const [videoUrl, setVideoUrl] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        const storageRef = ref(storage, fileUrl);
        getDownloadURL(storageRef)
            .then((url) => {
                setVideoUrl(url);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching video URL:", error);
                setLoading(false);
            });
    }, [fileUrl]);

    if (loading) {
        return <div className="overview-preview-loading">Loading preview...</div>;
    }

    if (!videoUrl) {
        return <div className="overview-preview-error">Unable to load preview</div>;
    }

    return (
        <div className="overview-video-preview-container">
            <video 
                src={videoUrl} 
                className="overview-video-preview"
                controls
                preload="metadata"
                poster={thumbnailUrl}
            />
        </div>
    );
};

const PDFPreview: React.FC<{ fileUrl: string }> = ({ fileUrl }) => {
    const [pdfUrl, setPdfUrl] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        const storageRef = ref(storage, fileUrl);
        getDownloadURL(storageRef)
            .then((url) => {
                setPdfUrl(`${url}#toolbar=0`);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching PDF URL:", error);
                setLoading(false);
            });
    }, [fileUrl]);

    if (loading) {
        return <div className="overview-preview-loading">Loading preview...</div>;
    }

    if (!pdfUrl) {
        return <div className="overview-preview-error">Unable to load preview</div>;
    }

    return (
        <div className="overview-pdf-preview-container">
            <iframe
                src={pdfUrl}
                className="overview-pdf-preview"
                title="PDF Preview"
            />
        </div>
    );
};

const ReferencePreview: React.FC<{ referenceId: string }> = ({ referenceId }) => {
    const { setShowAuthModal, setAuthModalMode } = useGlobalState();
    const reference = REFERENCES_TYPES_CONFIG.find(r => r.navUrl === referenceId);
    
    if (!reference) {
        return <div className="overview-preview-error">Reference not found</div>;
    }

    const previewItems = reference.referenceItems.slice(0, 6);
    const remainingCount = reference.referenceItems.length - 6;

    const handleSignUp = () => {
        setAuthModalMode('register');
        setShowAuthModal(true);
    };

    return (
        <div className="overview-reference-preview-container">
            <div className="overview-reference-preview-scroll">
                {previewItems.map((item: ReferenceItem, index: number) => (
                    <FlexRow 
                        key={index}
                        className="overview-reference-preview-item"
                        onClick={() => window.open(item.url, "_blank")}
                    >
                        <img src={item.image} alt={`${item.title} icon`} className="overview-reference-preview-item-image" />
                        <FlexCol gap={0.25} flex={1} style={{ minWidth: 0 }}>
                            <BCHeader4 text={item.title} style={{ fontSize: '0.9rem' }} />
                            <Body2 text={item.description} style={{ 
                                fontSize: '0.75rem',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden'
                            }} />
                            {item.tags && <BCTagList tags={item.tags} />}
                        </FlexCol>
                    </FlexRow>
                ))}
            </div>
            {remainingCount > 0 && (
                <div className="overview-reference-preview-more">
                    <span className="overview-reference-preview-more-text">
                        +{remainingCount} more APIs available
                    </span>
                    <button className="overview-reference-preview-more-button" onClick={handleSignUp}>
                        Sign up to see all →
                    </button>
                </div>
            )}
        </div>
    );
};

const ResumeAnalyzerPreview: React.FC = () => {
    const { setShowAuthModal, setAuthModalMode } = useGlobalState();
    const [uploadedFile, setUploadedFile] = useState<File | null>(null);

    const onDrop = useCallback((acceptedFiles: File[]) => {
        if (acceptedFiles.length > 0) {
            setUploadedFile(acceptedFiles[0]);
        }
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        multiple: false,
        maxFiles: 1,
        accept: { "application/pdf": [".pdf"] }
    });

    const handleAnalyze = () => {
        setAuthModalMode('register');
        setShowAuthModal(true);
    };

    const handleRemoveFile = () => {
        setUploadedFile(null);
    };

    return (
        <div className="overview-reference-preview-container">
            <FlexCol gap={.5} mBottom={1}>
                <FlexRow gap={.5} align={"center"}>
                    <BCIcon icon={ICONS.SEARCH} className="overview-tool-preview-icon"/>
                    <h4 className="overview-tool-preview-title">Resume Analyzer</h4>
                </FlexRow>

                <p className="overview-tool-preview-description">
                    Get AI-powered feedback on your resume including structure, clarity, and suggestions.
                </p>
            </FlexCol>


            {!uploadedFile ? (
                <div
                    {...getRootProps()}
                    className={`overview-tool-preview-dropzone ${isDragActive ? 'active' : ''}`}
                >
                    <input {...getInputProps()} />
                    <BCIcon icon={ICONS.UPLOAD} className="overview-tool-preview-dropzone-icon"/>
                    <p className="overview-tool-preview-dropzone-text">
                        Drag & drop your resume, or click to select
                    </p>
                    <span className="overview-tool-preview-dropzone-hint">Supports: PDF</span>
                </div>
            ) : (
                <div className="overview-tool-preview-uploaded">
                    <div className="overview-tool-preview-file">
                        <BCIcon icon={ICONS.FILE} className="overview-tool-preview-file-icon"/>
                        <div className="overview-tool-preview-file-info">
                            <span className="overview-tool-preview-file-name">{uploadedFile.name}</span>
                            <span className="overview-tool-preview-file-size">
                                {(uploadedFile.size / 1024).toFixed(1)} KB
                            </span>
                        </div>
                        <button className="overview-tool-preview-file-remove" onClick={handleRemoveFile}>
                            <BCIcon icon={ICONS.CLOSE}/>
                        </button>
                    </div>
                    <BCPrimaryButton
                        text="Sign Up to Analyze"
                        onClick={handleAnalyze}
                        style={{width: '100%'}}
                    />
                    <p className="overview-tool-preview-signup-hint">
                        Create a free account to analyze your resume!
                    </p>
                </div>
            )}
        </div>
    );
};

const InteractivePreview: React.FC<{ overviewType: LandingPageOverviewType }> = ({ overviewType }) => {
    if (overviewType.previewType === 'video' && overviewType.previewUrl) {
        return <VideoPreview fileUrl={overviewType.previewUrl} thumbnailUrl={overviewType.thumbnailUrl} />;
    }
    
    if (overviewType.previewType === 'pdf' && overviewType.previewUrl) {
        return <PDFPreview fileUrl={overviewType.previewUrl} />;
    }

    if (overviewType.previewType === 'reference' && overviewType.referenceId) {
        return <ReferencePreview referenceId={overviewType.referenceId} />;
    }

    if (overviewType.previewType === 'tool') {
        return <ResumeAnalyzerPreview />;
    }

    return null;
};

export const LandingPageOverviewSections: React.FC<{ isEducator: boolean }> = ({isEducator}) => {
    return (
        <FlexCol widthPercent={100} pVertical={4} className={'landing-page-overview-section-container'}>
            {/*<BCHeader2*/}
            {/*    text={"See for Yourself"}*/}
            {/*    textAlign="center"*/}
            {/*    mBottom={1.5}*/}
            {/*    fontSize={2.2}*/}
            {/*    fontWeight={300}*/}
            {/*/>*/}
            <LandingPageOverviewItem overviewType={LANDING_PAGE_OVERVIEW_TYPES.SECTION_1} isEducator={isEducator}/>
            <DividerSection />
            <LandingPageOverviewItem overviewType={LANDING_PAGE_OVERVIEW_TYPES.SECTION_2} isEducator={isEducator}/>
            <DividerSection />
            <LandingPageOverviewItem overviewType={LANDING_PAGE_OVERVIEW_TYPES.SECTION_5} isEducator={isEducator}/>
            {/*<DividerSection />*/}
            {/*<LandingPageOverviewItem overviewType={LANDING_PAGE_OVERVIEW_TYPES.SECTION_4} isEducator={isEducator}/>*/}
            {/*<DividerSection />*/}
            {/*<LandingPageOverviewItem overviewType={LANDING_PAGE_OVERVIEW_TYPES.SECTION_5} isEducator={isEducator}/>*/}
        </FlexCol>
    )
}

export const LandingPageOverviewItem: React.FC<{overviewType: LandingPageOverviewType, isEducator: boolean}> = ({overviewType, isEducator}) => {
    return (
        <FlexRow widthPercent={100} gap={3}  className={`landing-page-overview-section ${overviewType.isInverted ? 'is-inverted' : ''}`}>
            <CompactOverviewPreview preview={overviewType}>
                <InteractivePreview overviewType={overviewType} />
            </CompactOverviewPreview>
            <CompactOverviewText preview={overviewType} isEducator={isEducator}/>
        </FlexRow>
    )
}

export const CompactOverviewText: React.FC<{preview: LandingPageOverviewType, isEducator: boolean}> = ({preview, isEducator}) => {
    const { setShowAuthModal, setAuthModalMode, setShowEducatorInquiryModal } = useGlobalState();
    return (
        <FlexCol widthPercent={50} gap={1.5} className={'landing-overview-text-container'} alignSelf={"center"} heightPercent={100}>
            <FlexCol gap={.75} mBottom={.5}>
                {/*<span className="overview-step-label">Step {preview.step}</span>*/}
                <BCHeader3
                    text={isEducator ? preview.educationHeader : preview.header}
                    className="landing-overview-header"
                />
            </FlexCol>
            <FlexCol gap={2} heightPercent={100} className={'landing-overview-bullets-container'}>
                {preview.bullets.map((point, idx) => (
                    <FlexRow key={idx} gap={0.8} align="center">
                        <BCIcon icon={point.icon} style={{
                            fontSize: '1em',
                            color: preview.primary,
                            minWidth: '1.2em'
                        }}/>
                        <Body2 text={point.text} style={{
                            fontSize: '1.1rem',
                            color: 'var(--secondary-text-color)',
                            fontWeight: '400'
                        }}/>
                    </FlexRow>
                ))}
            </FlexCol>
            <FlexRow className={'landing-overview-cta-container'} mTop={1.5}>
                <BCPrimaryButton
                    text={isEducator ? preview.ctaEducatorText : preview.ctaText}
                    className={'landing-primary-cta-button'}
                    onClick={() => {
                        if (isEducator) {
                            setShowEducatorInquiryModal(true);
                        } else {
                            setAuthModalMode('register');
                            setShowAuthModal(true);
                        }
                    }}
                    iconRight={ICONS.RIGHT_ARROW}
                />
            </FlexRow>
        </FlexCol>
    )
}

export const CompactOverviewPreview: React.FC<{
    preview: LandingPageOverviewType;
    children: React.ReactNode;
}> = ({ preview, children }) => {
    return (
        <FlexCol widthPercent={50} className={'landing-overview-preview-container'} >
            <div style={{
                background: '#ffffff',
                borderRadius: '1em',
                padding: '1.5em',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
                position: 'relative',
                border: '1px solid #e9ecef',
            }}>
                {/*<FlexRow gap={0.5} align="center" mBottom={1}>*/}
                {/*    <div style={{*/}
                {/*        padding: '0.4em',*/}
                {/*        borderRadius: '0.5em',*/}
                {/*        display: 'flex',*/}
                {/*        alignItems: 'center',*/}
                {/*        justifyContent: 'center'*/}
                {/*    }}>*/}
                {/*        <BCIcon icon={preview.icon} style={{*/}
                {/*            color: preview.primary,*/}
                {/*            fontSize: '1em'*/}
                {/*        }}/>*/}
                {/*    </div>*/}
                {/*    <BCHeader4 text={preview.previewTitle} style={{*/}
                {/*        color: '#2c3e50',*/}
                {/*        fontSize: '1em',*/}
                {/*        fontWeight: '600'*/}
                {/*    }}/>*/}
                {/*</FlexRow>*/}
                
                {/*<div style={{*/}
                {/*    background: preview.background,*/}
                {/*    borderRadius: '0.8em',*/}
                {/*    border: `1.5px solid ${preview.borderColor}`,*/}
                {/*    overflow: 'hidden',*/}
                {/*    boxShadow: `inset 0 2px 4px ${preview.primary}08, 0 4px 12px ${preview.primary}12`*/}
                {/*}}>*/}
                    {children}
                {/*</div>*/}
                {preview.previewCaption && (
                    <p className="overview-preview-caption">{preview.previewCaption}</p>
                )}
            </div>
        </FlexCol>
    )
}

const DividerSection: React.FC = () => {
    return (
        <FlexRow widthPercent={100} justify={"center"}>
            <div className={'overview-divider-line'} />
        </FlexRow>
    )
}
